import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { AxiosError, AxiosResponse } from 'axios'

import { axiosInstance } from '../../helpers'
import { LeadPipePixel } from '../../models/Outreach/types'

const LEADPIPE_PIXEL_QUERY_KEY = ['leadpipe-pixels']

export const useLeadPipePixel = () => {
    const queryClient = useQueryClient()

    const { data: pixelsResponse, isLoading, error } = useQuery<
        AxiosResponse<LeadPipePixel[]>,
        Error
    >({
        queryKey: LEADPIPE_PIXEL_QUERY_KEY,
        queryFn: () => axiosInstance.get('/outreach/leadpipe-pixels/'),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    })

    const createPixel = useMutation({
        mutationFn: (request: { domain: string }) =>
            axiosInstance.post('/outreach/leadpipe-pixels/', request),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: LEADPIPE_PIXEL_QUERY_KEY,
            })
            toast.success('LeadPipe pixel created successfully')
        },
        onError: (error: AxiosError) => {
            const status = error.response?.status
            if (status === 409) {
                toast.error('A pixel already exists for this apartment')
            } else if (status === 502) {
                toast.error(
                    'Could not connect to LeadPipe. Please try again later.',
                )
            } else {
                toast.error('Failed to create LeadPipe pixel')
            }
        },
    })

    const pixels = pixelsResponse?.data
    const pixel = pixels && pixels.length > 0 ? pixels[0] : null

    return {
        pixel,
        isLoading,
        error,
        createPixel,
    }
}
